<script setup lang="ts">
import { computed, ref, watchEffect } from 'vue';
import VueMultiselect from 'vue-multiselect';

const props = defineProps<{
  question: string;
  countries: object;
}>();

const countriesArray = computed(() => {
  return Object.entries(props.countries).map(([key, value]) => {
    return { key, value };
  });
});

const selectedCountry = ref<{
  key: string;
  value: string;
}>();

const emit = defineEmits(['answer-selected']);

watchEffect(() => {
  if (selectedCountry.value) {
    emit('answer-selected', selectedCountry.value.key);
  }
});
</script>

<template>
  <div class="step-select">
    <h3 class="mb-30">{{ props.question }}</h3>

    <div class="step-select__form-input">
      <label
        class="h4"
        for="location"
        >I’m from</label
      >
      <VueMultiselect
        v-model="selectedCountry"
        :options="countriesArray"
        label="value"
        selectLabel=""
        :close-on-select="false"
        openDirection="bottom"
        :optionHeight="40"
      >
        <template #noResult>
          <span>No results found</span>
        </template>
      </VueMultiselect>
    </div>
  </div>
</template>
